(function () {
  var SELECTOR = '.aasaved-cart-header h1, .aasaved-cart-header h2, .aasaved-cart-header h3, .aasaved-cart-header h4, .aasaved-cart-header h5, .aasaved-cart-header h6';

  function demote(heading) {
    var p = document.createElement('p');
    for (var i = 0; i < heading.attributes.length; i++) {
      p.setAttribute(heading.attributes[i].name, heading.attributes[i].value);
    }
    p.classList.add('aasaved-cart-header__title');
    while (heading.firstChild) p.appendChild(heading.firstChild);
    heading.replaceWith(p);
  }

  function demoteAll(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTOR)) demote(root);
    var found = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < found.length; i++) demote(found[i]);
  }

  function start() {
    demoteAll(document.body);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) demoteAll(added[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
